var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScoreBoard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 165,
    viewBox: "0 0 200 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 18.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 118.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 138.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 68.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 88.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 101.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 121.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 71.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 138.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 18.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 149.5,
    y: 38.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 38.5,
    width: 29,
    height: 10,
    rx: 1.5,
    fill: "black",
    stroke: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 195,
    height: 160,
    stroke: "black",
    strokeWidth: 5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 164,
    width: 163,
    height: 5,
    rx: 2.5,
    transform: "rotate(-90 33 164)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 164,
    width: 163,
    height: 5,
    rx: 2.5,
    transform: "rotate(-90 76 164)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 164,
    width: 163,
    height: 5,
    rx: 2.5,
    transform: "rotate(-90 119 164)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 164,
    width: 163,
    height: 5,
    rx: 2.5,
    transform: "rotate(-90 162 164)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 56.5,
    width: 195,
    height: 106,
    stroke: "black",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreBoard);
export default __webpack_public_path__ + "static/media/score-board.2549985075bb8037df116b00bca0caac.svg";
export { ForwardRef as ReactComponent };